import { getInvoices } from '~/api/invoices';
import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { humanizeTimestamp } from '~/utils/date-helper';
import { getDigitalVoucherTransaction } from '~/api/digital-voucher';
import { specialMessageSchema, generateSpecialMessage } from '~/utils/special-message-config';

export default {
  methods: {
    /**
     * Check status of DANA Topup transactions
     * @command - [apicall] checkDanaTopupStateAndSLA [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkDanaTopupStateAndSLA(currentTrx = null) {
      const responses = {
        danaTopupIsProcessedAndWithinSLA: '[apiresponse] danaTopupIsProcessedAndWithinSLA [/apiresponse]',
        danaTopupIsProcessedAndOutsideSLA: '[apiresponse] danaTopupIsProcessedAndOutsideSLA [/apiresponse]',
        danaTopupState: '[apiresponse] danaTopupIs<state> [/apiresponse]',
        chcekDanaTopupStateAndSLAError: '[apiresponse] checkDanaTopupStateAndSLAError [/apiresponse]',
      };

      try {
        if (!currentTrx) {
          this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
          return;
        }

        // Retrieve Invoice Data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        // Retrieve DANA Topup transaction data using transaction object from the invoice
        const { data: digitalVoucherData } = await getDigitalVoucherTransaction(this.$axios, invoiceTrx.id);

        const { state } = digitalVoucherData;
        const createdAt = new Date(invoiceData.created_at);
        const dateNow = new Date();
        const in15minutes = 15 * 60 * 1000;
        const SLA = dateNow - createdAt;
        const waitDate = createdAt.setMinutes(createdAt.getMinutes() + 15);

        /**
         * AC 1
         * state is "processed" and within SLA (under 15 minutes)
         */
        if (state === 'processed' && SLA <= in15minutes) {
          const msgPayload1 = {
            ...specialMessageSchema.generic,
            text: 'Maaf ya, juragan. Setelah Acha cek, top up juragan masih diproses'
          };
          const msgPayload2 = {
            ...specialMessageSchema.generic,
            text: `Harap tunggu hingga ${humanizeTimestamp(
              waitDate,
              '%dd% %month% %yyyy% pukul %hh%:%mi%'
            )} waktu setempat, ya!`,
          };

          this.sendMessage({
            msg: generateSpecialMessage(msgPayload1),
            nick: 'agent:trigger', // impersone Acha Bot
            displayName: 'Acha'
          });
          this.sendMessage({
            msg: generateSpecialMessage(msgPayload2),
            nick: 'agent:trigger',
            displayName: 'Acha', // impersone Acha Bot
          });
          this.$zopim.sendChatMsg(responses.danaTopupIsProcessedAndWithinSLA);
          return;
        }

        /**
         * AC 2
         * state is 'processed' and outside SLA (more than 15 minutes)
         */
        if (state === 'processed' && SLA > in15minutes) {
          this.$zopim.sendChatMsg(responses.danaTopupIsProcessedAndOutsideSLA);
          return;
        }

        /**
         * AC 3
         * state is other than 'processed'
         */
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.danaTopupState.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.chcekDanaTopupStateAndSLAError);
        console.error('[ERROR] Something is wrong when trying to check DANA SLA', error);
      }
    }
  },
};
